import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'src/utils/AxiosConfig'

// Async thunk to fetch year list and related data
export const getYearList = createAsyncThunk(
  'appStaffWorkStatus/getYearList',
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get('/api/project_staff_work_status')
      return response.data
    } catch (error) {
      return rejectWithValue(error.response ? error.response.data : { message: error.message })
    }
  }
)

export const setStaffWorkDetails = createAsyncThunk(
  'appStaffWorkStatus/setStaffWorkDetails',
  async (start_end_yr, { rejectWithValue }) => {
    try {
      const response = await axios.get('/api/project_staff_work_status/setStaffWorkDetails', {
        params: {
                start_year: start_end_yr.start_year,
                start_month: start_end_yr.start_month,
                end_year: start_end_yr.end_year,
                end_month: start_end_yr.end_month,
                search_user_id: start_end_yr.search_user_id,
                }
        })
      return response.data
    } catch (error) {
      return rejectWithValue(error.response ? error.response.data : { message: error.message })
    }
  }
)

export const appStaffWorkStatusSlice = createSlice({
  name: 'appStaffWorkStatus',  initialState: {
    data: {
      yearList: [],
      monthList: [],
      userList: [],
      dateParams: {},
      staff_work_details: {},
      staffData: {}
    },              
    status: 'idle',
    message: null,
    errors: null
  },
  reducers: {
    resetStaffWorkStatus: (state) => {
      state.data = {}
      state.status = 'idle'
      state.message = null
      state.errors = null
    },
    resetState: (state) => {
      state.status = 'idle'
      state.message = null
      state.errors = null
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getYearList.pending, (state) => {
        state.status = 'loading'
      })
     .addCase(getYearList.fulfilled, (state, action) => {
  state.status = 'succeeded'
  // Merge instead of replacing
  state.data = {
    ...state.data,
    ...action.payload.data
  }
})

      .addCase(getYearList.rejected, (state, action) => {
        state.status = 'failed'
        state.message = action.payload?.message
        state.errors = action.payload?.errors
      })

       builder
      .addCase(setStaffWorkDetails.pending, (state) => {
        state.status = 'loading'
      })
     .addCase(setStaffWorkDetails.fulfilled, (state, action) => {
      state.status = 'succeeded'
      state.data.staff_work_details = action.payload  // or action.payload.data if wrapped
    })


      .addCase(setStaffWorkDetails.rejected, (state, action) => {
        state.status = 'failed'
        state.message = action.payload?.message
        state.errors = action.payload?.errors
      })
  }
})
  
export const { resetStaffWorkStatus, resetState } = appStaffWorkStatusSlice.actions
export default appStaffWorkStatusSlice.reducer
